<template>

	<li class="submenu" :class="{active:showUserMenu}">

		<div v-if="menuText" @click="onTriggerClick" v-click-outside="hideDropdown" class="menu-trigger">
			<div class="text-trigger">{{ menuText }}
				<i class="fa fa-caret-down"></i>
			</div>

			<div v-if="iconClass" class="icon-trigger"><i class="fas" :class="iconClass"></i></div>
		</div>

		<div v-else @click="onTriggerClick" v-click-outside="hideDropdown" class="menu-trigger">
			<slot name="element-trigger" class="menu-trigger"></slot>
		</div>

		<div class="popup menu" :style="{'minWidth': minWidth + 'px'}" :class="{'right-side':right, 'center': center }">
			<slot></slot>
		</div>
	</li>

</template>

<script>

import Vue from 'vue';
import { clickOutside } from '../directives/click-outside';

export default {
	name: 'DropdownMenu',
	data() {
		return {
			showUserMenu: false
		};
	},
	computed:{
		right () {
			return this.position === 'right';
		},
		center () {
			return this.position === 'center';
		}
	},
	directives:{
		clickOutside
	},
	props: {
		menuText: String,
		iconClass: String,
		position: String,
		minWidth: Number
	},
	methods: {
		hideDropdown(){
			this.showUserMenu = false;
		},
		onTriggerClick(e){
			const noAnchorSlots = !this.$slots.default;
			if (noAnchorSlots) {
				this.$router.push('/');
				return;
			}

			this.showUserMenu = !this.showUserMenu;
		}
	}
};
</script>

<style scoped>
	.center.popup:before {
		left: 0;
		right: 0;
		margin: auto;
	}
	.menu-trigger div {
		padding: .75em 0;
	}
	.submenu {
		overflow: visible;
	}
	.submenu.button {
		padding: 0;
	}
	.button > .menu-trigger div {
		padding: 0.5em 1em;
	}
	.menu-trigger {
		cursor: pointer;
	}

	.text-trigger {
		display: block;
	}

	.icon-trigger {
		display: none;
	}

	@media only screen and (max-width: 599px) {
		.page-header .text-trigger {
			display: none;
		}
		.icon-trigger {
			display: block;
		}
	}


</style>



// WEBPACK FOOTER //
// ./src/components/DropdownMenu.vue